import SeasonalBanner, {
  SeasonalBannerColors,
} from "../SeasonalBanner/SeasonalBanner"
import useStrings from "../../localization/useStrings"
import images from "../../utils/images"

const halloweenColors: SeasonalBannerColors = {
  containerBackground: "linear-gradient(to bottom, #1B2A34 0%, #010101 100%)",
  text: "white",
  countdownBox: "#1B2A34",
  countdownValue: "white",
  countdownLabel: "#62646B",
  ctaBackground: "#FB8101",
  ctaText: "black",
}

const HalloweenBanner = () => {
  const strings = useStrings()

  return (
    <SeasonalBanner
      icon={<div className={images.halloween.banner.class} />}
      title={strings.halloweenSale.title}
      colors={halloweenColors}
      titleFontSize="16px"
    />
  )
}

export default HalloweenBanner
